<template>
  <div>
    <v-navigation-drawer
      fixed
      :mini-variant.sync="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      app
    >
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar>
                <img src="/static/box-orange.png"/>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <a href="/" router>[ NetPlus Software ]</a>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click.native.stop="miniVariant = !miniVariant">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <sidebar-menu v-if="isAuthenticated"></sidebar-menu>
    </v-navigation-drawer>
    <v-toolbar app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark to="/login" v-if="!isAuthenticated">Sign in</v-btn>
      <profile v-else></profile>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout wrap row pb-1>
          <v-flex xs12>
            <span class="title">{{ $route.meta.description }}</span>
          </v-flex>
        </v-layout>
        <v-slide-y-transition mode="out-in">
          <v-layout wrap align-center>
            <v-flex xs12>
            <router-view></router-view>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>
      </v-container>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; 2017 &nbsp;</span>
      <div class="caption">
        บริษัท เน็ทพลัส ซอฟท์แวร์ จำกัด &nbsp;
        เลขที่ 598 อาคารคิวเฮ้าส์เพลินจิต ชั้น 6 ห้องเลขที่ 2 ถ.เพลินจิต ลุมพินี ปทุมวัน กทม. 10330
      </div>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Profile from './Profile'
import SidebarMenu from './SidebarMenu'

export default {
  name: 'Dash',
  components: { Profile, SidebarMenu },
  data () {
    return {
      clipped: false,
      fixed: true,
      right: true,
      rightDrawer: true,
      title: 'NetPlus',
      signin: false
    }
  },
  computed: {
    ...mapState(['access_token', 'roles', 'username', 'isAuthenticated']),
    drawer: {
      get () { return this.$store.state.drawer },
      set (value) { this.$store.commit('drawer', value) }
    },
    miniVariant: {
      get () { return this.$store.state.miniVariant },
      set (value) { this.$store.commit('miniVariant', value) }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dash.vue